import { Api, Model, ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutServiceTransitTimeList } from "./autogen/AutogenLayoutServiceTransitTimeList";
import { Label, SelectionMode, Snackbar, TableRowDisplayEvent } from "@mcleod/components";
import { CommonTooltips } from "@mcleod/common";

export class ServiceTransitTimeList extends AutogenLayoutServiceTransitTimeList {

    async onLoad() {
        this.mainDataSource.search();
        const carrierConnectRecord: ModelRow = await Model.searchSingleRecord("lme/powerbroker/contract-management-control", { id: "CC" })
        if (carrierConnectRecord != null && carrierConnectRecord.get("is_active") === "Y") {
            Api.post("lme/powerbroker/carrier-connect-api-control").then(result => {
                if (result) {
                    const message: string = "Unable to add or update records due to: " +result?.data[0]?.message;                
                    if (result?.data[0]?.success != null && result.data[0].success === false) {
                        const disabledTooltip = "Error connecting to Carrier Connect, unable to add new records."
                        this.disableAddEditFunctionality(message, disabledTooltip);
                    }
                }
            });
        }
        else {
            const disableMessage: string = "Carrier Connect is inactive, unable to add new records.";
            this.disableAddEditFunctionality(disableMessage, disableMessage);
        }

    }

    private disableAddEditFunctionality(message: string, disabledTooltip: string) {
        this.tableServiceTransitTime.selectionMode = SelectionMode.NONE;
        Snackbar.showWarningSnackbar(message, {persist: true});
        const buttonAdd = this.tableServiceTransitTime.headingPanel.findComponentById("buttonAdd");
        if (buttonAdd != null) {
            buttonAdd.enabled = false;
            buttonAdd.tooltip = null;
            buttonAdd.disabledTooltip = disabledTooltip;
        }
    
    }

    /** This is an event handler for the onRowDisplay event of tableServiceTransitTime. */
    tableServiceTransitTimeOnRowDisplay(event: TableRowDisplayEvent) {
        const labelIncludeSaturday: Label = event.target.findComponentById("labelIncludeSaturday") as Label;
        const labelIncludeSunday: Label = event.target.findComponentById("labelIncludeSunday") as Label;
        const tableRow = event.getTableRow();
        if (tableRow.data != null) {
            const modelRow = tableRow.data;
            if (StringUtil.equalsIgnoreCase(modelRow.get("include_saturday"), "Y"))
                labelIncludeSaturday.text = "Yes";
            else
                labelIncludeSaturday.text = "No";
            if (StringUtil.equalsIgnoreCase(modelRow.get("include_sunday"), "Y"))
                labelIncludeSunday.text = "Yes";
            else
                labelIncludeSunday.text = "No";

            const labelPayee: Label = event.target.findComponentById("labelName") as Label;
            CommonTooltips.setTooltipContentLayout(labelPayee, modelRow.get("payee_id"), "lme/powerbroker/CarrierQuickInfo", { minWidth: 128, minHeight: 140 });
        }
    }
}
